import {Observable} from "rxjs/Observable";
import {EventEmitter} from "@angular/core";
import {Link} from "../../domain/link";
import {HateoasCache} from "./hateoas-cache";
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import {HateoasComposeItem} from "./hateoas-compose";
import {BehaviorSubject} from "rxjs/BehaviorSubject";

import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/forkJoin';


export class HateoasResolver {

    private _nesting: number = 0;
    private _cache : HateoasCache = new HateoasCache();
    private _uniqueHttpCalls : Map<string, Link> = new Map<string, Link>();
    private _rootItem : any;
    private _subject: BehaviorSubject<any>;

    constructor(public http: Http) {}

    public resolveArray(hateoasItems : any, hateoasComposeItems : Map<string, HateoasComposeItem>) : BehaviorSubject<any> {

        this._rootItem = [];

        this._subject = new BehaviorSubject(null);

        hateoasItems.forEach((hateoasItem : any) => {
            this._rootItem.push(hateoasItem.item);
        });

        this.resolveItemList(hateoasItems, hateoasComposeItems);

        return this._subject;
    }

    private resolveItemList(hateoasItems : any, hateoasComposeItems : Map<string, HateoasComposeItem>) {

        this._nesting++;

        let observables: Map<Link, Observable<any>> = new Map<Link, Observable<any>>();
        hateoasItems.forEach((hateoasItem : any) => {
            observables = this.resolveLinks(hateoasItem, hateoasComposeItems, observables);
        });

        if (observables.size == 0) {
            this.emitObject();
            return;
        }
        let done = false;
        Observable.forkJoin(Array.from(observables.values())).takeWhile(() => !done).subscribe((data : any) => {

            let nestedItems : any = [];

            Array.from(observables.keys()).forEach((link : Link, index:number) => {

                if (!this._cache.has(link.href)) {
                    this._cache.set(link.href, data[index]);
                }

                hateoasItems.forEach((hateoasItem : any) => {

                    hateoasItem.links.forEach((l: Link) => {

                        if (l.rel == link.rel && l.href == link.href) {
                            if (data[index].item == null) {
                                hateoasItem.item[link.rel] = data[index];
                                return;
                            } else {
                                hateoasItem.item[link.rel] = data[index].item;
                                nestedItems.push(this.injectLevel(data[index], hateoasItem, link));
                            }

                        }
                    });

                });

            });
            if (nestedItems.length > 0) {
                this.resolveItemList(nestedItems, hateoasComposeItems);
            }
            this.emitObject();
            done = true;

        });

    }

    public resolve(hateoasItem : any, hateoasComposeItems : Map<string, HateoasComposeItem>) : BehaviorSubject<any> {

        this._rootItem = hateoasItem.item;

        this._subject = new BehaviorSubject(null);

        this.resolveItem(hateoasItem, hateoasComposeItems);

        return this._subject;
    }

    private resolveItem(hateoasItem : any, hateoasComposeItems : Map<string, HateoasComposeItem>) {

        let observables : Map<Link, Observable<any>> = this.resolveLinks(hateoasItem, hateoasComposeItems);

        if (observables == null) {
            return;
        }

        this._nesting++;

        if (observables.size == 0) {
            this.emitObject();
            return;
        }
        let done = false;
        Observable.forkJoin(Array.from(observables.values())).takeWhile(() => !done).subscribe((data : any) => {

            Array.from(observables.keys()).forEach((link : Link, index:number) => {

                if (!this._cache.has(link.href)) {
                    this._cache.set(link.href, data[index]);
                }

                hateoasItem.links.forEach((l: Link) => {
                    if (l.rel == link.rel && l.href == link.href) {

                        if (data[index].item == null) {
                            hateoasItem.item[link.rel] = data[index];
                        } else {
                            hateoasItem.item[link.rel] = data[index].item;
                            this.resolveItem(this.injectLevel(data[index], hateoasItem, link), hateoasComposeItems);
                        }

                    }
                });

            });

            this.emitObject();
            done = true;

        });
    }

    private resolveLinks(hateoasItem: any, hateoasComposeItems : Map<string, HateoasComposeItem>, observables : Map<Link, Observable<any>> = new Map<Link, Observable<any>>()) : any {

        if (hateoasItem.links == null) {
            return null;
        }

        let hrefsAdded : Set<string> = new Set<string>();
        Array.from(observables.keys()).forEach((link : Link) => {
            hrefsAdded.add(link.href);
        });

        hateoasItem.links
            .filter((link : Link) => !hrefsAdded.has(link.href))
            .filter((link : Link) => hateoasComposeItems.has(this.buildLevel(hateoasItem, link)))
            .forEach((link : Link) => {
            observables.set(link, this.toObservable(link));
        });

        return observables;

    }

    private emitObject() : void {
        if (--this._nesting > 0) {
            return;
        }
        this._subject.next(this._rootItem);
    }

    private toObservable(link: Link): Observable<any> {
        if (this._cache.has(link.href)) {
            return Observable.of(this._cache.get(link.href).getData());
        } else {
            return this.http.get(link.href).map(this.extractData);
        }
    }

    private extractData(res: Response) {
        const body = res.json() || { };
        return body.data || body;
    }

    private injectLevel(hateoasItem : any, parentHateoasItem : any, link : Link) {
        hateoasItem.level = this.buildLevel(parentHateoasItem, link);
        return hateoasItem;
    }

    private buildLevel(hateoasItem : any, link : Link) : string {
        if (hateoasItem.level != null) {
            return hateoasItem.level + '.' + link.rel;
        }
        return link.rel;
    }

}